<template>
  <v-chip v-bind="$attrs" :style="chipStyle" >
    {{label}}
  </v-chip>
</template>

<script>
import colorMixin from "@/components/mixins/ColorMixin";

export default {
  name: "AgentActiveChip",
  mixins: [colorMixin],
  inheritAttrs: false,
  props: {
    value: { type:[String,Boolean], default: 'inactive' }, // 'active' | 'inactive',
    useBoolean: {type:Boolean, default: false}
  },
  computed: {
    config() {
      return this.agentActiveColors(this.useBoolean ? this.value === true ? 'active' : 'inactive' : this.value) || this.agentActiveColors('inactive')
    },
    label() {
      return this.config.label
    },
    chipStyle() {
      return {
        backgroundColor: this.config.backgroundHex,
        color: this.config.colorHex
      }
    }
  },
}
</script>


<style scoped>

</style>